module.exports = __webpack_public_path__ + "static/media/PFID.e5f242be.png";